common.View.create('canvas.blocks.custom.sliderAlfa.Block', {
    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            margin: 30,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            navText: ["<i class='fal fa-long-arrow-left'></i>", "<i class='fal fa-long-arrow-right'></i>"],
            navContainer: this.element.find('.arrow-container'),
            dots: false,
            responsive: {
                300: {
                    items: 1,
                },
                640: {
                    items: 3,
                },
                1000: {
                    items: 5,
                },
            },
        });
    },
});
